document.addEventListener('DOMContentLoaded', function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function updateAllCountdowns() {
    var timers = document.querySelectorAll('.sh-countdown-timer');
    if (!timers.length) return;

    var now = Date.now();

    timers.forEach(function (timer) {
      var endStr = timer.getAttribute('data-sh-countdown-end');
      if (!endStr) return;

      var endTime = new Date(endStr).getTime();
      if (isNaN(endTime)) return;

      var diff = endTime - now;

      // Aktion vorbei → komplettes Banner / Badge entfernen
      if (diff <= 0) {
        var container = timer.closest('.sh-info, .promo-mini-badge');
        if (container) {
          container.remove();
        } else {
          timer.remove();
        }
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var parts = [];

      if (days > 0) {
        parts.push(days + 'd');
      }

      parts.push(
        pad(hours) + ':' + pad(minutes) + ':' + pad(seconds)
      );

      timer.textContent = parts.join(' ');
    });
  }

  function initObserver() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var timer = entry.target;
        if (entry.isIntersecting) {
          timer.classList.add('sh-timer-pulse');
        } else {
          timer.classList.remove('sh-timer-pulse');
        }
      });
    }, { threshold: 0.2 });

    document.querySelectorAll('.sh-watch-for-pulse').forEach(function (timer) {
      observer.observe(timer);
    });
  }

  // Countdown laufend aktualisieren
  updateAllCountdowns();
  setInterval(updateAllCountdowns, 1000);

  // Puls-Effekt nur, wenn im Viewport
  initObserver();
});
